// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpContainer {
  display: flex;
  display: contents;
  column-gap: 25px;
}
.otpContainer .divClass {
  background: var(--light-gray-900);
  width: 56px;
  height: 56px;
  transform: rotate(45deg);
  text-align: center;
}
.otpContainer .divClass input {
  text-align: center;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 5px;
  font-size: 45px;
  font-style: normal;
  font-weight: 400;
  line-height: 52px;
  background: transparent;
  color: var(--color-black);
  transform: rotate(-45deg);
}
.otpContainer .divClass input:focus {
  outline: transparent;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/otpInput.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;AACN;AAEI;EACE,oBAAA;AAAN","sourcesContent":[".otpContainer {\n  display: flex;\n  display: contents;\n  column-gap: 25px;\n\n  .divClass {\n    background: var(--light-gray-900);\n    width: 56px;\n    height: 56px;\n    transform: rotate(45deg);\n    text-align: center;\n\n    input {\n      text-align: center;\n      width: 56px;\n      height: 56px;\n      border: none;\n      border-radius: 5px;\n      font-size: 45px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 52px;\n      background: transparent;\n      color: var(--color-black);\n      transform: rotate(-45deg);\n    }\n\n    input:focus {\n      outline: transparent;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
